import * as React from "react";
import { useHistory } from "react-router-dom";

import { Button, DesignToken, Text } from "@livechat/design-system-react-components";

import { AccordionItem } from "components/accordion-item/AccordionItem";
import { Label, Line } from "components/custom-section";
import Flex from "components/layout/Flex";
import { StatusTag } from "components/status-tag/StatusTag";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { ITicket, TicketSilo } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

import {
  EmptySubject,
  StyledLink,
  StyledTicketLink,
  StyledTitle,
  TitleWrapper,
} from "./TicketDetailsRecentTicketsStyles";
import { SectionWrapper } from "./styles";

interface IProps {
  tickets: ITicket[] | null;
  onMergingModalOpen?(): void;
  currentTicket: ITicket;
  isViewer: boolean;
  isAgentInTicketTeam: boolean;
  isMobile: boolean;
  opened: boolean;
  onHeaderClick(): void;
}

export const TicketDetailsRecentTickets: React.FC<IProps> = ({
  tickets,
  onMergingModalOpen,
  currentTicket,
  isViewer,
  isAgentInTicketTeam,
  isMobile,
  opened,
  onHeaderClick,
}) => {
  const history = useHistory();
  const isRecentTicket = currentTicket.silo === TicketSilo.Tickets;
  // @ts-expect-error TS(2531): Object is possibly 'null'.
  const recentTickets = tickets.slice(0, 5);
  // @ts-expect-error TS(2531): Object is possibly 'null'.
  const hasMoreTickets = tickets.length > 5;
  const isDisabled =
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    !(tickets.length > 0 && isAgentInTicketTeam && !isViewer && !currentTicket.parentTicket) || !isRecentTicket;

  const handleMergingModalOpen = React.useCallback(
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e: any) => {
      e.stopPropagation();
      e.preventDefault();
      if (isAgentInTicketTeam && !isViewer && !currentTicket.parentTicket) {
        // @ts-expect-error TS(2722): Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        onMergingModalOpen();
        trackEngagement("Ticket: Merging tickets modal opened successfully", EventPlace.Tickets);
      } else {
        trackEngagement("Ticket: Merging tickets modal open failed", EventPlace.Tickets);
      }
    },
    [currentTicket.parentTicket, isAgentInTicketTeam, isViewer, onMergingModalOpen]
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleShowAllTickets = () => {
    history.push(`/tickets/search?query=${encodeURIComponent(currentTicket.requester.email)}`);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleSearchArchive = () => {
    trackEngagement("Ticket details: See requester tickets in archive", EventPlace.Tickets);
    history.push(
      `/tickets/search?query=${encodeURIComponent(currentTicket.requester.email)}&silo=${TicketSilo.Archive}`
    );
  };

  return (
    <SectionWrapper borderTop>
      <AccordionItem title="Requester’s tickets" opened={opened} onHeaderClick={onHeaderClick}>
        <TitleWrapper>
          <StyledTitle>Recent tickets</StyledTitle>
          {tickets && !isMobile && (
            <StyledLink data-testid="merge-button" disabled={isDisabled} onClick={handleMergingModalOpen}>
              Merge
            </StyledLink>
          )}
        </TitleWrapper>

        <>
          {recentTickets.length > 0 ? (
            recentTickets.map(ticket => (
              <Label
                key={ticket.id}
                label={<StatusTag status={ticket.status} />}
                value={
                  <StyledTicketLink
                    data-testid={`recent-tickets-${ticket.id}-link`}
                    to={`/tickets/${ticket.id}`}
                    className="fs-mask"
                  >
                    {ticket.subject || <EmptySubject>No subject</EmptySubject>}
                  </StyledTicketLink>
                }
              />
            ))
          ) : (
            <Text customColor={withVar(DesignToken.ContentBasicDisabled)}>No recent requester’s tickets</Text>
          )}
          <>
            {hasMoreTickets && (
              <>
                <Line />
                <Button kind="link-light" onClick={handleShowAllTickets}>
                  Show all recent tickets
                </Button>
              </>
            )}
            <Flex column marginTop="20px" gap="8px">
              <Text bold customColor={withVar(DesignToken.ContentBasicPrimary)}>
                Archived tickets
              </Text>
              <Text customColor={withVar(DesignToken.ContentBasicDisabled)}>
                <Button kind="link-light" onClick={handleSearchArchive}>
                  Search Archive
                </Button>
                &nbsp;to view this requester&apos;s archived tickets.
              </Text>
            </Flex>
          </>
        </>
      </AccordionItem>
    </SectionWrapper>
  );
};

export default React.memo(TicketDetailsRecentTickets);
